export default __webpack_public_path__ + "static/media/Avatar-9.05bd0513.svg";